export enum ResourceReferenceType {
  DailyResource = 'DAILY_RESOURCE',
  HoursResource = 'HOURS_RESOURCE',
  Optional = 'OPTIONAL',
  Product = 'PRODUCT',
  Stay = 'STAY',
}

export const ResourceReferenceTypeTranslations: Record<ResourceReferenceType, string> = {
  [ResourceReferenceType.Product]: $localize`:@@resourceReference.type.product:Prodotto singolo`,
  [ResourceReferenceType.HoursResource]: $localize`:@@resourceReference.type.hoursResource:Prenotabile a ore`,
  [ResourceReferenceType.DailyResource]: $localize`:@@resourceReference.type.dailyResource:Prenotabile a giorni`,
  [ResourceReferenceType.Optional]: $localize`:@@resourceReference.type.optional:Optional camere`,
  [ResourceReferenceType.Stay]: $localize`:@@resourceReference.type.stay:Pernottamento`,
};

export const ResourceReferenceTypeIcons: Record<ResourceReferenceType, string> = {
  [ResourceReferenceType.Stay]: 'z_bed',
  [ResourceReferenceType.DailyResource]: 'uil uil-calendar',
  [ResourceReferenceType.HoursResource]: 'uil uil-clock',
  [ResourceReferenceType.Optional]: 'uil uil-tv-retro',
  [ResourceReferenceType.Product]: 'uil uil-coffee',
};

/** Segmento di URL della lista di ogni tipo di servizio, al plurale (es. `/products`). Le route di edit usano invece il singolare (es. `/product/edit`) */
export const ResourceReferenceTypeListPaths: Record<ResourceReferenceType, string> = {
  [ResourceReferenceType.Product]: 'products',
  [ResourceReferenceType.Stay]: 'stays',
  [ResourceReferenceType.Optional]: 'optionals',
  [ResourceReferenceType.DailyResource]: 'daily-resources',
  [ResourceReferenceType.HoursResource]: 'hours-resources',
};

/** Ordine di visualizzazione dei tipi di servizio (menu, route, filtro della modale) */
export const RESOURCE_REFERENCE_TYPES_ORDER: readonly ResourceReferenceType[] = [
  ResourceReferenceType.Product,
  ResourceReferenceType.Stay,
  ResourceReferenceType.Optional,
  ResourceReferenceType.DailyResource,
  ResourceReferenceType.HoursResource,
];
